<template>
  <div>
    <vs-button
      color="primary"
      type="filled"
      icon-pack="feather"
      icon="icon-plus"
      size="small"
      @click="addPoint"
      >Add Pick Up / Drop Point</vs-button
    >
    <br />
    <div v-if="showAddPoint == true">
      <vx-card title="Add New Point">
        <vs-input
          label="Invoice Id"
          v-model="currentAddPoint.invoiceId"
          class="w-full mt-4"
        />
        <vs-input
          label="Purchase Order (PO) Id"
          v-model="currentAddPoint.poId"
          class="w-full mt-4"
        />
        <label class="vs-input--label">Select Client Profile</label>

        <v-select
          :options="allClients"
          placeholder="Select Client"
          v-model="currentAddPoint.clientInfo"
          :clearable="false"
          value="id"
          label="id"
        >
          <template slot="option" slot-scope="option" class="w-full mt-5">
            {{
              '(Client Id:' +
              option.id +
              ') ' +
              JSON.parse(option.clientInfo).name
            }}
          </template>
          <template
            slot="selected-option"
            slot-scope="option"
            class="w-full mt-5"
          >
            {{
              '(Client Id:' +
              option.id +
              ') ' +
              JSON.parse(option.clientInfo).name
            }}
          </template>
        </v-select>
        <label class="vs-input--label">Select Pickup/Drop Off Location</label>
        <v-select
          :options="mapPOIData"
          placeholder="Select Location"
          v-model="currentAddPoint.location"
          :clearable="false"
          value="id"
          label="id"
        >
          <template slot="option" slot-scope="option">
            {{ option.metadata.name }} ({{
              option.metadata.lat + ',' + option.metadata.lng
            }})
          </template>
          <template slot="selected-option" slot-scope="option">
            {{ option.metadata.name }} ({{
              option.metadata.lat + ',' + option.metadata.lng
            }})
          </template>
        </v-select>
        <vs-input
          v-if="pickups.length == 0"
          type="date"
          label="Start Date"
          v-model="currentAddPoint.date"
          class="w-full mt-4"
        />
        <vs-input
          v-if="pickups.length == 0"
          type="time"
          label="Start Time"
          v-model="currentAddPoint.time"
          class="w-full mt-4"
        />
        <vs-input
          v-if="currentAddPoint.requireDeadline == true"
          type="date"
          label="Delivery Deadline Date"
          v-model="currentAddPoint.deadlineDate"
          class="w-full mt-4"
        />
        <vs-input
          v-if="currentAddPoint.requireDeadline == true"
          type="time"
          label="Delivery Deadline Time"
          v-model="currentAddPoint.deadlineTime"
          class="w-full mt-4"
        />
        <br />
        <vs-checkbox v-model="currentAddPoint.requireDeadline" class="mb-3"
          >Delivery has DEADLINE</vs-checkbox
        >
        <vs-checkbox v-model="currentAddPoint.requireSignature" class="mb-3"
          >Require E-SIGNATURE Confirmation</vs-checkbox
        >
        <label class="vs-input--label">Goods Type</label>
        <v-select
          :options="[
            'Electrical',
            'Cement',
            'Food & Bevarage',
            'Industrial Machinery',
            'Household Goods',
            'Others',
          ]"
          v-model="currentAddPoint.goodsType"
          placeholder="Select Goods Type"
          class="w-full mt-5"
        />
        <label class="vs-input--label">Goods Weightage (in Tonnes)</label>
        <input
          type="number"
          v-model="currentAddPoint.goodsWeight"
          class="w-full mt-5"
        />

        <vs-textarea
          v-model="currentAddPoint.remarks"
          label="Description"
          class="mb-0 md:mt-10 mt-6"
          rows="3"
        />
        <br />
        <vs-button
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-plus"
          size="small"
          @click="addPoint2"
          >Add to Route</vs-button
        >
      </vx-card>
    </div>

    <vx-card
      :title="index + 1 + '. Location: ' + item.location.metadata.name"
      v-for="(item, index) in pickups"
      :key="index"
    >
      <li class="suggestion-group-suggestion cursor-pointer">
        <span
          ><b>{{
            'Client: ' + JSON.parse(item.clientInfo.clientInfo).name
          }}</b></span
        ><br />
        <span>{{
          'Invoice Num: ' + item.invoiceId + ' | PO Num: ' + item.poId
        }}</span
        ><br />
        <span v-if="item.date != null">{{
          'Start Date/Time: ' + item.date + ' ' + item.time
        }}</span
        ><br />
        <span>{{
          'Details: ' + item.goodsWeight + '  tonnes / ' + item.goodsType
        }}</span
        ><br />
        <span>{{ 'Require Signature: ' + item.requireSignature }}</span
        ><br />
        <span>{{
          'Deadline: ' + item.deadlineDate + ' | ' + item.deadlineTime
        }}</span
        ><br />
        <span>{{ 'Remarks: ' + item.remarks }}</span
        ><br />
      </li>
    </vx-card>

    <br /><br />
    <vs-button @click="calculateAndDisplayRoute"
      >Check Optimized Route</vs-button
    >
    <br /><br />

    <div id="directions-panel"></div>

    <div id="map" ref="map"></div>
  </div>
</template>

<script>
const today = new Date();
import vSelect from 'vue-select';
import { Loader } from '@googlemaps/js-api-loader';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

export default {
  props: {
    unitSelection: Array,
    userInfo: Object,
    mapPOIData: Array,
    geoPOIData: Array,
    allClients: Array,
    pickups: Array,
    groute: Object,
  },
  data() {
    return {
      showAddPoint: false,
      currentAddPoint: {
        invoiceId: '',
        poId: '',
        clientInfo: null,
        goodsType: '',
        goodsWeight: '',
        remarks: '',
        location: null,
        time: '',
        date: '',
        location: null,
        deadlineTime: '',
        deadlineDate: '',
        requireSignature: false,
        requireDeadline: false,
      },
      selection: { timeRange: '', type: '', units: [] },
      devices: [],
      loaded: false,
      isLoading: false,
      loader: null,
      map: null,
      streetMap: null,
      markerCluster: null,
      units: [],
      unitSelection: [],
      selectedUnitsUnrefined: { id: 1, type: 'ALL', label: 'All Assets' },
      selectedUnitsRefined: [],
      mapMarkerData: [],
      mapPOIData: [],
      selectedUnitDetails: null,
      locations: null,
      loadStreetView: false,
      defaultMapClass: 'vx-col w-full md:w-5/5 lg:w-4/4 mt-12 md:mt-0',
      popup: null,
      gmarkers: [],
      poi: [],
      directionsService: null,
      directionsRenderer: null,
      directions: { start: '', end: '', waypoints: [] },
      total: { time: 0, distance: 0, reachTime: '' },
      refinedPOI: [],
      pickupTime: new Date(),
    };
  },
  methods: {
    addPoint() {
      const self = this;
      self.showAddPoint = !self.showAddPoint;
    },
    addPoint2() {
      const self = this;
      if (self.currentAddPoint.location == null) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select location',
          color: 'warning',
        });
      }

      if (self.pickups.length == 0 && self.currentAddPoint.date == null) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select time and date',
          color: 'warning',
        });
      }
      if (self.pickups.length == 0 && self.currentAddPoint.time == null) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select time and date',
          color: 'warning',
        });
      }
      self.pickups.push(self.currentAddPoint);
      self.currentAddPoint = {
        invoiceId: '',
        poId: '',
        clientInfo: null,
        goodsType: '',
        goodsWeight: '',
        remarks: '',
        location: null,
        time: '',
        date: '',
        location: null,
        deadlineTime: '',
        deadlineDate: '',
        requireSignature: false,
        requireDeadline: false,
      };
      self.showAddPoint = !self.showAddPoint;
    },

    calculateAndDisplayRoute() {
      const self = this;

      if (self.pickups.length < 2) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select at least 2 points to begin a trip',
          color: 'warning',
        });
      }
      self.total = { time: 0, distance: 0, reachTime: '' };
      const waypts = [];

      const numOfPoints = self.pickups.length;
      let i = 0;
      self.pickups.forEach((place) => {
        if (i != 0 || i != numOfPoints - 1) {
          //        console.log(waypts)
          waypts.push({
            location: {
              lat: self.pickups[i].location.metadata.lat,
              lng: self.pickups[i].location.metadata.lng,
            },
            stopover: true,
          });
        } else {
          console.log('-');
        }
        i++;
      });

      self.groute = {
        origin: {
          lat: self.pickups[0].location.metadata.lat,
          lng: self.pickups[0].location.metadata.lng,
        },
        destination: {
          lat: self.pickups[numOfPoints - 1].location.metadata.lat,
          lng: self.pickups[numOfPoints - 1].location.metadata.lng,
        },
        waypoints: waypts,
        optimizeWaypoints: true,
        travelMode: google.maps.TravelMode.DRIVING,
      };
      console.log(self.groute);
      self.directionsService.route(
        {
          origin: {
            lat: self.pickups[0].location.metadata.lat,
            lng: self.pickups[0].location.metadata.lng,
          },
          destination: {
            lat: self.pickups[numOfPoints - 1].location.metadata.lat,
            lng: self.pickups[numOfPoints - 1].location.metadata.lng,
          },
          waypoints: waypts,
          optimizeWaypoints: true,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (response, status) => {
          if (status === 'OK' && response) {
            self.directionsRenderer.setDirections(response);
            const route = response.routes[0];
            const summaryPanel = document.getElementById('directions-panel');
            summaryPanel.innerHTML = '';
            let i;
            // For each route, display summary information.
            for (let i = 0; i < route.legs.length; i++) {
              const routeSegment = i + 1;
              summaryPanel.innerHTML += `<b>Route Segment: ${routeSegment}</b><br>`;
              var startAddr = route.legs[i].start_address;
              var endAddr = route.legs[i].end_address;
              const startIndex = self.poi.findIndex(
                (x) => x.address === startAddr,
              );
              const endIndex = self.poi.findIndex((x) => x.address === endAddr);

              if (self.poi[startIndex] != undefined) {
                startAddr = self.poi[startIndex].name;
              }
              if (self.poi[endIndex] != undefined) {
                endAddr = self.poi[endIndex].name;
              }
              summaryPanel.innerHTML += `${startAddr} <b>to</b> `;
              summaryPanel.innerHTML += `${endAddr}<br>`;
              summaryPanel.innerHTML += `${route.legs[i].distance.text} / ${route.legs[i].duration.text} <br><br>`;
              self.total.time = self.total.time + route.legs[i].duration.value;
              //   console.log(route.legs[i].duration.value)
              self.total.distance =
                self.total.distance + route.legs[i].distance.value;

              if (i == route.legs.length - 1) {
                summaryPanel.innerHTML +=
                  `<b>Trip Summary - ${(self.total.distance / 1000).toFixed(
                    1,
                  )}km / ${moment
                    .utc(self.total.time * 1000)
                    .format('HH:mm')} hrs ` +
                  ` / ETA : ${moment(self.pickupTime)
                    .add(self.total.time, 's')
                    .format(
                      'DD/MM/YY HH:MM:ss',
                    )} based on current traffic conditions</b>`;
              }
            }
          } else {
            window.alert(`Directions request failed due to ${status}`);
          }
        },
      );
    },
  },
  compare(strA, strB) {
    for (var result = 0, i = strA.length; i--; ) {
      if (typeof strB[i] === 'undefined' || strA[i] == strB[i]);
      else if (strA[i].toLowerCase() == strB[i].toLowerCase()) result++;
      else result += 4;
    }
    const res =
      1 -
      (result + 4 * Math.abs(strA.length - strB.length)) /
        (2 * (strA.length + strB.length));
    if (res > 0.9) return true;
    if (res <= 0.9) return false;
  },
  components: {
    vSelect,
    DatePicker,
    Loader,
    moment,
  },
  mounted() {
    const self = this;
    self.loader = new Loader(this.$loader);
    self.loader.load().then(() => {
      self.map = new google.maps.Map(self.$refs.map, {
        center: { lat: 3.910187, lng: 102.119262 },
        zoom: 8,
        gestureHandling: 'greedy',
      });
      self.directionsService = new google.maps.DirectionsService();
      self.directionsRenderer = new google.maps.DirectionsRenderer();
      self.directionsRenderer.setMap(self.map);

      const poi = self.mapPOIData.map((data, i) => {
        const poi = new google.maps.Polygon(data);

        google.maps.event.addListener(poi, 'click', function (event) {
          alert(data.metadata.name);
        });
        poi.setMap(self.map);

        return poi;
      });

      self.isLoading = false;
    });
  },
};
</script>
<style>
#map {
  height: 70vh;
}
</style>
